import { React } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SnackbarProvider from "react-simple-snackbar";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "remixicon/fonts/remixicon.css";
import "./index.css";

import ScrollToTop from "./components/ScrollToTop";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import QrEntry from "./pages/QrEntry";
import QrExit from "./pages/QrExit";
import Register from "./pages/Register";
import Finish from "./pages/Finish";
import PmoHome from "./pages/PmoHome";

const root = createRoot(document.getElementById("root"));

export default function App() {
	return (
		<BrowserRouter>
			<ScrollToTop />
			<Routes>
				<Route path="pmo/*">
					<Route index element={<PmoHome />} />
				</Route>
				<Route index element={<Home />} />
				<Route path="qr/entry/:id" element={<QrEntry />} />
				<Route path="qr/exit/:id" element={<QrExit />} />
				<Route path="register/:id" element={<Register />} />
				<Route path="finish" element={<Finish />} />
			</Routes>
		</BrowserRouter>
	);
}

root.render(
	<SnackbarProvider>
		<App />
	</SnackbarProvider>
);
